function noWhiteSpaceValidator({ input, msgs }) {
  if (input.indexOf(' ') !== -1) {
    return (msgs && msgs.msg) || 'Must not contain spaces.';
  }

  return null;
}

export default noWhiteSpaceValidator;
